module.exports = __webpack_public_path__ + "static/squid-ball-0b5b93c73f7ae995071610f592b8f157.jpg";